export { CompanyPage as default } from '@/components/pages/Company'
